import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.87812 18.0896L7 17.2115L11.6667 12.5448L7 7.87813L7.87812 7L12.5448 11.6667L17.2115 7L18.0896 7.87813L13.4229 12.5448L18.0896 17.2115L17.2115 18.0896L12.5448 13.4229L7.87812 18.0896Z", fill: "#1C1B1F" }));
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
